<template>
  <div class="main-business-composition">
    <RkSwitch v-model="activedTab" :options="options" />
    <VueEcharts :option="option" />
    <RkTable :data="segmentViews" :show-footer="false" :header-split-line="false">
      <RkTableColumn prop="name" label="主营业务" align="left">
        <template slot-scope="{ row, index }">
          <div class="legend-item">
            <span class="legend-icon" :style="{ background: getColor(index) }"></span>
            <span class="legend-name one-line">{{ row.name }}</span>
          </div>
        </template>
      </RkTableColumn>
      <RkTableColumn prop="operatingIncome" :width="`${postcssPatch(100)}`">
        <template #header>
          {{ $t('收入') + (currency ? currency : '') }}
        </template>
        <template slot-scope="{ row }">{{ $digitjs(row.operatingIncome).convert() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="incomeRatio" label="占比" :width="`${postcssPatch(90)}`">
        <template slot-scope="{ row }">{{ $digitjs(row.incomeRatio).unit('%').rounded() }}</template>
      </RkTableColumn>
    </RkTable>
  </div>
</template>

<script>
import RkSwitch from '@/components/common/RkSwitch.vue'
import VueEcharts from '@/components/common/VueEcharts.vue'
import { colour } from '@/utils/constant.js'
import { postcssPatch } from '@/utils/postcssPatch'

const TYPE_VIEWS_MAP = {
  hk: ['F', 'I'],
  us: ['F'],
  hs: [12, 6]
}

const REPORT_TYPE_MAP = {
  F: '年报',
  I: '中报',
  12: '年报',
  6: '中报'
}

export default {
  components: { RkSwitch, VueEcharts },
  props: ['segmentType'],
  data() {
    return {
      activedTab: '',
      options: [],
      segmentData: new Map()
    }
  },
  computed: {
    currency() {
      const c = this.segmentViews[0]?.currency ?? ''

      return c ? `(${c})` : ''
    },
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    segmentViews() {
      return this.segmentData.get(this.activedTab) ?? []
    },
    option() {
      return {
        color: colour,
        dataset: {
          source: this.segmentViews.slice(0, -1)
        },
        series: [
          {
            name: '主营占比',
            type: 'pie',
            radius: ['50%', '100%'],
            encode: {
              name: 'name',
              value: 'incomeRatio'
            },
            label: {
              show: false
            },
            emphasis: {
              disabled: true
            }
          }
        ]
      }
    }
  },
  created() {
    this.getSegment()
  },
  methods: {
    postcssPatch,
    getColor(index) {
      return colour[index] ?? '#009E56'
    },
    // 兼容A股segmentType参数
    formatA(val) {
      if (this.market !== 'hs') return val

      if (val === 'B') return 1100
      else if (val === 'G') return 1200

      return val
    },
    async getSegment() {
      const res = await this.$post(this.$api.f10[this.market] + '/finance/segment', {
        symbol: this.symbol,
        segmentType: this.formatA(this.segmentType),
        startDate: '1990-01-01'
      })

      this.dataFormatter(res.data)
    },
    dataFormatter(data) {
      const segmentData = new Map()
      const options = []

      // 过滤数据
      const filterData = data?.filter(({ reportType }) => TYPE_VIEWS_MAP[this.market].includes(reportType)) ?? []
      // 定义属性
      const customData = filterData.map((item) => {
        const { reportType, reportDate } = item
        return {
          ...item,
          customType: this.$t(`$x年${REPORT_TYPE_MAP[reportType]}`, {
            x: this.$dayjs(reportDate).format('YYYY')
          })
        }
      })
      // 4期数据
      customData.forEach((item) => {
        const { customType } = item
        const mapItem = segmentData.get(customType)
        if (mapItem) {
          mapItem.push(item)
        } else {
          if (segmentData.size < 4) {
            segmentData.set(customType, [item])
          }
        }
      })
      // 选项 排序 合计
      segmentData.forEach((value, key, map) => {
        options.push({ label: key, value: key })
        map.set(
          key,
          value.sort((a, b) => {
            return b.incomeRatio - a.incomeRatio
          })
        )
        const total = value.reduce(
          (result, curr) => {
            const operatingIncome = result.operatingIncome + curr.operatingIncome
            const incomeRatio = result.incomeRatio + curr.incomeRatio
            return { ...result, operatingIncome, incomeRatio }
          },
          { name: '合计', operatingIncome: 0, incomeRatio: 0 }
        )
        map.get(key)?.push(total)
      })
      this.segmentData = segmentData
      this.activedTab = options[0]?.value
      this.options = [options]
    }
  }
}
</script>

<style lang="scss" scoped>
.main-business-composition {
  .echarts-container {
    margin: 15px 0;
  }
  .legend-item {
    display: flex;
    align-items: center;
  }
  .legend-icon {
    flex-shrink: 0;
    margin-right: 5px;
    width: 8px;
    height: 8px;
  }
}
</style>
